import React,{ Component } from "react";
import { connect } from "react-redux";
import { getZones, deleteZone,setZonePageInfo } from "../../actions/actionZones";
import { Link } from "react-router-dom";
import { Row, Col, Button, Modal, ModalHeader, ModalBody, ModalFooter, Card, CardBody, CardHeader } from "reactstrap";
import { NotificationManager } from "react-notifications";
import LoadingSpinner from "../../components/LoadingSpinner/index";
import "react-table/react-table.css";
import Proptypes from "prop-types";
import BreadCrumbCompo from "../../components/Breadcrumb/BreadCrumbCompo";
import DataTable from "../../components/Table/Table";
import {getLicenses} from "../../actions/actionSystemInfo";

const routes = [
    {name: "Home",path:"/userdashboard",isActive: false},
    {name: "Zones",path:"/zones",isActive: true}
];

class Zones extends Component{
    constructor(props){
        super(props);

        this.state = {
            modal: false,
            pages: 1,
            zoneId: null,
        };

        this.deleteConfirm = this.deleteConfirm.bind(this);
        this.deleteZoneAction = this.deleteZoneAction.bind(this);
        this.handleDeleteSuccess = this.handleDeleteSuccess.bind(this);
        this.handleDeleteError = this.handleDeleteError.bind(this);
        this.cancelDelete = this.cancelDelete.bind(this);
    }

    componentDidMount() {
        this.props.getZones();
    }

    deleteConfirm(zoneId){
        this.setState({modal: !this.state.modal,
            zoneId: zoneId});
    }

    cancelDelete(){
        this.setState({modal: !this.state.modal}); 
    }

    deleteZoneAction(){
        this.props.deleteZone(this.state.zoneId).
            then(() => this.handleDeleteSuccess()).
            catch(() => this.handleDeleteError());
    }	

    handleDeleteSuccess(){
        const {deleteZoneErrorMessage} = this.props;
        if(deleteZoneErrorMessage) {
            NotificationManager.error(deleteZoneErrorMessage,"Delete Zone Failed", 3000);
        }else{
            NotificationManager.success("Successfully Deleted Zone","Delete Zone", 3000);
            this.setState({modal: false});
            this.props.getZones();
        }
    }

    handleDeleteError(){
        const {deleteZoneError} = this.props;
        if(deleteZoneError){
            NotificationManager.error(deleteZoneError,"Failed to Delete Zone", 3000);
            this.props.history.push("/zones");
        }else{
            NotificationManager.error("Failed to Delete Zone","Delete Zone", 3000);
            this.props.history.push("/zones");
        }
    }

    render(){
        if (this.props.getZonesLoading){
            return (<div> <LoadingSpinner /></div>);
        }

        const { zones } = this.props;

        const columns = [
            {
                type: "text",
                name: "Zone Name",
                accessor: "zone_name",
                filterable: true,
                sortable: true
            },
            {
                type: "text",
                name: "Managers",
                accessor: "managers.length",
                filterable: false,
                sortable: true
            },
            {
                type: "text",
                name: "Agents",
                accessor: "servers.length",
                filterable: true,
                sortable: true
            },
            {
                type: "text",
                name: "Sessions",
                accessor: "num_kasms",
                filterable: true,
                sortable: true
            },
            {
                type: "text",
                name: "Available Slots",
                accessor: "available_slots",
                filterable: true,
                sortable: true
            }
        ];

        const actions = [
            { id: "view", icon: "fa-eye", description: "View" },
            { id: "edit", icon: "fa-pencil", description: "Edit" },
            { id: "delete", icon: "fa-trash", description: "Delete" },
        ];

        const onAction = (action, item) => {
            switch (action) {
                case "view":
                    this.props.history.push(`/viewzone/${item.zone_id}`);
                break;

                case "edit":
                    this.props.history.push(`/updatezone/${item.zone_id}`);
                break;

                case "delete":
                    this.deleteConfirm(item.zone_id);
                break;
            }
        }
        
        return (
            <div className="profile-page">
                <BreadCrumbCompo routes={routes}/>
                <Row>
                    <Col sm={{ size: 10, order: 3, offset: 1 }}>
                        <Card >
                            <CardHeader>
                            <div className="title-head">
                                <i className="fa fa-map-o"></i> <strong>Deployment Zones</strong>
                                </div>
                                <Link className="pull-right add-btn" to={{ pathname: "/createzone" }}>
                                    <button className="pull-right adduser-btn" size="sm" color="dark">
                                    <i className="fa fa-plus" aria-hidden="true"></i>
                                   Add Zone
                                    </button>
                                </Link> 
                               
                            </CardHeader>
                            <CardBody className="p-0">
                                <DataTable
                                    id="zones"
                                    data={zones}
                                    columns={columns}
                                    actions={actions}
                                    onAction={onAction}
                                />
                            </CardBody>
                        </Card>
                    </Col>
                </Row>

                <Modal isOpen={this.state.modal} toggle={this.cancelDelete} className="user-modal">
                    <ModalHeader toggle={this.cancelDelete}>Are you sure you want to delete this Zone?
                    </ModalHeader>
                    <ModalFooter>
                        <Button onClick={this.cancelDelete} size="sm" 
                        className="cancel-button"
                        color=" basic"> Close</Button>
                        <Button onClick={this.deleteZoneAction} size="sm" 
                        className="delete-button"
                        color="danger"> Delete</Button>
                    </ModalFooter>
                </Modal>
            </div>
        );
    }
}

Zones.propTypes = {
    getZones: Proptypes.func.isRequired,
    deleteZone: Proptypes.func.isRequired,
    deleteZoneErrorMessage: Proptypes.func,
    deleteZoneError: Proptypes.func,
    history: Proptypes.object.isRequired,
    zones: Proptypes.array,
    createZoneLoading: Proptypes.bool,
    className: Proptypes.func
};


export default connect(state => ({
    zones: state.zones.zones || [],
    createZoneLoading: state.zones.createZoneLoading || false,
    deleteZoneErrorMessage: state.zones.deleteZoneErrorMessage || null,
    deleteZoneLoading: state.zones.deleteZoneLoading || false,
    deleteZoneError: state.zones.deleteZoneError || null,
    getZonesLoading: state.zones.getZonesLoading || null,
    pages : {pageSize : state.zones.pageSize, pageNo : state.zones.pageNo},
}), 
dispatch => ({
    getZones: () => dispatch(getZones()),
    getLicenses: () => dispatch(getLicenses()),
    deleteZone: (data) => dispatch(deleteZone(data)),
    setPageInfo : (data)=> dispatch(setZonePageInfo(data)),
}))(Zones);


// WEBPACK FOOTER //
// ./src/views/Zones/Zones.js